import axios from "axios";
import getIdSelector from "./../state/selectors/ClientSelectors/getIdSelector";
import getTokenSelector from "../state/selectors/ClientSelectors/getTokenSelector";
import logoutAction from "../state/actions/ClientActions/logoutAction";
import { store } from "./../state/store";

axios.interceptors.request.use(
    function(config) {
        const state = store.getState();
        const token = getTokenSelector(state as any);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function(err) {
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    function(response) {
        return response;
    },
    function(error) {
        if (error.response.status === 403) {
            const state = store.getState();
            const userId = getIdSelector(state as any);
            if (userId) {
                store.dispatch(logoutAction());
            }
        }
        return Promise.reject(error);
    }
);
